module.exports = __webpack_public_path__ + "img/idcard2.e9591a14.png";